import React, { useEffect, useState } from "react";
import { Table, Input, Switch } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import config from "../../services/config.json";

const Authors = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 15,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    name: "",
  });

  const activateAuthor = async (record) => {
    try {
      const response = await axios.post(
        `${config.apiEndPoint}recover_authors`,
        { id: record.id }
      );

      if (response?.data?.status == 1) {
        setData((prevData) => prevData.filter((item) => item.id !== record.id));
        setPagination((prev) => ({
          ...prev,
          total: Math.max((prev.total || 1) - 1, 0),
        }));
        toast.success("Author restored successfully");
      } else {
        toast.error(response?.data?.message || "Failed to restore author");
      }
    } catch (error) {
      console.error("Error activating author:", error);
      toast.error("Failed to restore author");
    }
  };

  const handleFilterChange = (field, value) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);
    fetchData({
      pagination: { ...pagination, current: 1 },
      filters: newFilters,
    });
  };

  const fetchData = async (params = {}) => {
    setLoading(true);
    try {
      const response = await axios.get(`${config.apiEndPoint}deleted_authors`, {
        params: {
          page: params.pagination?.current || 1,
          per_page: params.pagination?.pageSize || 15,
          name: params.filters?.name || "",
          id: params.filters?.id || "",
          image: params.filters?.image || "",
          updated_at: params.filters?.updated_at || "",
          active: params.filters?.active || "",
          designation: params.filters?.designation || "",
        },
      });

      const result = response.data;

      setData(result.authors || result.data || []);
      setPagination({
        current: result.current_page,
        pageSize: result.per_page,
        total: result.total,
      });
    } catch (error) {
      console.error("Failed to fetch authors:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData({ pagination, filters });
  }, []);

  const handleTableChange = (pagination) => {
    fetchData({ pagination, filters });
  };

  const columns = [
    {
      title: "No.",
      key: "index",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
    },
    {
      title: "Image",
      dataIndex: "image",
      key: "image",
      render: (text) => {
        return (
          <img
            src={text ? text : ""}
            alt="Author Image"
            style={{ width: "150px", height: "auto", objectFit: "contain" }}
          />
        );
      },
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      render: (text) => {
        if (!text) return "";
        return text.charAt(0).toUpperCase() + text.slice(1);
      },
    },
    {
      title: "Status",
      dataIndex: "active",
      key: "active",
      render: (text, record) => (
        <Switch
          checked={text == 1 || text == true}
          onChange={() => activateAuthor(record)}
          style={{
            backgroundColor:
              text == 1 || text == true ? "#dab35c" : undefined,
          }}
        />
      ),
    },
    {
      title: "Deletion Date",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text) => {
        return text && text !== "null" ? text.split(" ")[0] : "-";
      },
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2>Deleted Authors</h2>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          marginBottom: 16,
          marginTop: 25,
        }}
      >
        <Input
          placeholder="Filter by Name"
          value={filters.name}
          onChange={(e) => handleFilterChange("name", e.target.value)}
          style={{ width: 220 }}
        />
      </div>

      <Table
        columns={columns}
        rowKey={(record, index) => record.id || index}
        dataSource={data}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Authors;
